import React, {Component} from "react";
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import PropTypes from "prop-types";

export class InputField extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        const placeholder = this.props.placeholder;
        const unit = this.props.unit;
        const prepend = this.props.prepend;
        const isMissing = this.props.isMissing;
        let optionItems;
        if (this.props.options) {
            optionItems = this.props.options.map((option) =>
                <option key={option.value} value={option.value}>{option.name || option.value}</option>
            );
        }
        return <InputGroup className="botSpace">
            {prepend && <InputGroupAddon addonType="prepend">{prepend}</InputGroupAddon>}
            <Input placeholder={placeholder} onChange={this.handleChange} value={this.props.value}
                   type={this.props.type} min="0" maxLength="512" step="any">
                {optionItems}
            </Input>
            {unit && <InputGroupAddon addonType="append">{unit}</InputGroupAddon>}
            {isMissing && <span className="d-flex align-items-center"><span className="asterisk">*</span></span>}
        </InputGroup>;
    }
}

InputField.propTypes = {
    value: PropTypes.any,
    placeholder: PropTypes.string,
    unit: PropTypes.string,
    prepend: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    isMissing: PropTypes.bool
};